
import React, { useState, createContext, useContext, useEffect } from "react";
// import { QRCodeContext } from "./QRCodeProvider";



// const Default_QR = require('../options_02.json')
// Create a new context
export const AppContext = createContext();

// Create a context provider component
export const AppProvider = ({ children }) => {
  // const { qrCodeData, updateQRCodeData } = useContext(QRCodeContext);
  const [appData, setAppData] = useState(false)
  const [userData, setUserData] = useState()
  const [transactions, setTransactions] = useState()
  const [musicOn, setMusicOn] = useState(false)
  const [showInterfaceText, setShowInterfaceText] = useState(false)
  const [interfaceText, setInterfaceText] = useState(false)
  const [actionError, setActionError] = useState(null)
  const [actionText, setActionText] = useState(null)
  const [currentFloor, setCurrentFloor] = useState('1')
  const [currentView, setCurrentView] = useState('cockpit')

  const [geoData, setGeoData] = useState(false)

  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [weather, setWeather] = useState({
    temp: "--",
    feelsLike: "--",
    conditionText: "Scanning...",
    windSpeed: 0,
    precipitation: 0,
    isSevere: false,
    severeReason: null,
  });


  const updateAppData = (newData) => {
    setAppData((prevState) => ({
      appData,
      userData,
      transactions,
      showInterfaceText,
      interfaceText,
      geoData,
      weather,
      musicOn,
      actionError,
      currentFloor,
      currentView,
      actionText,
      isLoggedIn,
      ...userData,
      ...prevState,
      ...newData,
    }));

  };


  return (
    <AppContext.Provider value={{
      appData,
      updateAppData,

      userData,
      setUserData,
      transactions,
      setTransactions,
      geoData,
      setGeoData,
      musicOn,
      setMusicOn,
      weather,
      setWeather,
      showInterfaceText,
      setShowInterfaceText,
      currentFloor,
      setCurrentFloor,
      currentView,
      setCurrentView,
      interfaceText,
      setInterfaceText,
      actionError,
      setActionError,
      actionText,
      setActionText,

      isLoggedIn,
      setIsLoggedIn,


    }}>
      {children}
    </AppContext.Provider>
  );
};
export const AppState = () => {
  return useContext(AppContext);
};